export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-loading/index.js